import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {PAGES_AND_PATHS} from '../../../../../constants/pages-and-paths';
import {ActivatedRoute} from '@angular/router';
import {BlogsHttpService} from '../../../../../services/http-services/blogs/blogs-http.service';
import {debounceTime} from 'rxjs/operators';
import {ChunkUploadService} from '../../../../../services/helpers/chunk-upload-service.service';
import {BlogSectionType} from '../../../../../enums/blog-enums';


@Component({
  selector: 'app-edit-blogs',
  templateUrl: './edit-blog.component.html'
})
export class EditBlogComponent implements OnInit {
  formTriedToSubmit = false;
  editBlogForm!: FormGroup;
  urlParams: {blogId: number | null} = {
    blogId: null
  };
  coverImageUrl: any;
  blogCategories: any = [
    {name: 'Igraonice'},
    {name: 'Ketering'},
    {name: 'Torte'},
    {name: 'Animatori'},
    {name: 'Dekoracije'},
    {name: 'Fotografi'},
    {name: 'Pokloni'},
    {name: 'Dogadjaji'},
    {name: 'Ostalo'},
  ];

  addNewBlogElementDropdown = [
    {name: 'Naslov'},
    {name: 'Text'},
    {name: 'Slika'},
    {name: 'Video'}
  ];

  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote'],

      // [{'header': 1}, {'header': 2}],               // custom button values
      [{list: 'ordered'}, {list: 'bullet'}],
      // [{script: 'sub'}, {script: 'super'}],      // superscript/subscript
      [{indent: '-1'}, {indent: '+1'}],          // outdent/indent
      // [{direction: 'rtl'}],                         // text direction

      // [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
      // [{'header': [1, 2, 3, 4, 5, 6, false]}],

      // [{'color': []}, {'background': []}],          // dropdown with defaults from theme
      // [{'font': []}],
      [{align: []}],

      // ['clean'],                                       // remove formatting button

      // ['link', 'image', 'video',]                   // link and image, video
      ['link']                                         // link

    ]
  };
  totalProgress = 0;
  isUploading = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly BlogSectionType = BlogSectionType;

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private toastService: ToastrService,
              private chunkUploadService: ChunkUploadService,
              private blogsHttpService: BlogsHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.activatedRoute.params.subscribe(params => {
      if (params.blogId) {
        this.urlParams.blogId = params.blogId;
        this.getBlog();
      }
    });
  }

  buildForm(): void {
    this.editBlogForm = this.formBuilder.group({
      category: ['', Validators.required],
      author_name: ['', Validators.required],
      cover_image: ['', Validators.required],
      title: ['', Validators.required],
      intro_text: ['', Validators.required],
      sections: [[], Validators.required],
      is_featured: [false, Validators.required],
      is_active: [false, Validators.required],
      is_saved: [false, Validators.required]
    });
    this.editBlogForm.valueChanges.pipe(debounceTime(5000)).subscribe(values => {
      this.saveBlogDraftChanges();
    });
  }

  getBlog(): void {
    this.blogsHttpService.getBlog(this.urlParams).then(res => {
      this.coverImageUrl = res.data.image?.full_path;
      this.editBlogForm.patchValue(res.data);
      (res.data.sections === null)
        ? this.editBlogForm.controls.sections.patchValue([])
        : this.editBlogForm.controls.sections.patchValue(JSON.parse(res.data.sections));
    });
  }

  onFileChange(event: any, sectionIndex?: number): void {
    // let progress = '0';
    this.isUploading = true;
    const files: FileList = event.target.files;
    const fileArray = Array.from(files);
    fileArray.forEach((file: File) => {
      let prevProgress = 0;
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
        this.toastService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
        return;
      } else if (file?.size > 100485760) {
        this.toastService.warning(`Slika ${file.name} je veća od 10MB.`);
        return;
      } else {
        const chunkSize = 5 * 1024 * 1024;  // 5MB per chunk
        const {blogId} = this.urlParams;
        this.chunkUploadService.uploadFile(file, blogId, chunkSize).subscribe({
          next: (data) => {
            this.totalProgress = (this.totalProgress - prevProgress + data.progress);
            prevProgress = data.progress;
            if (data.progress === 100) {
              (sectionIndex || sectionIndex === 0)
                ? this.editBlogForm.controls.sections.value[sectionIndex].value = data.fileName.filename
                : this.editBlogForm.controls.cover_image.patchValue(data.fileName.filename);
            }
          },
          complete: () => {
            setTimeout( () => {
              this.isUploading = false;
              this.totalProgress = 0;
              if (sectionIndex || sectionIndex === 0) {
                this.editBlogForm.controls.sections.value[sectionIndex].fullPath = URL.createObjectURL(file);
              } else {
                this.coverImageUrl = URL.createObjectURL(file);
              }
              this.saveBlogDraftChanges();
            }, 400);
          },
          error: (err) => {
            console.error('Upload error:', err);
          }
        });
        this.fileInput.nativeElement.value = '';
      }
    });
  }

  removeFile(): void {
    this.coverImageUrl = '';
  }

  addNewSection(section: any): void {
    this.editBlogForm.controls.sections.patchValue([...this.editBlogForm.controls.sections.value, section === BlogSectionType.image ? {type: section, value: '', id: crypto.randomUUID(), fullPath: ''} : {type: section, value: '', id: crypto.randomUUID()}]);
  }

  saveBlogDraftChanges(): void {
    const requestBody = {...this.editBlogForm.value, sections: JSON.stringify(this.editBlogForm.controls.sections.value)};
    this.blogsHttpService.putBlog(this.urlParams, requestBody).then(() => {

    });
  }

  submitEditBlogForm(): void {
    if (this.editBlogForm.valid) {
      this.blogsHttpService.putBlog(this.urlParams, this.editBlogForm.value).then(res => {

      });
    }
  }


}
